export interface UpdateDefaultParameterInterLibraryLoanDefaultValueRequest {
  id: string
  revision: number
}

export function UpdateDefaultParameterInterLibraryLoanDefaultValueRequestToJSON(
  value: UpdateDefaultParameterInterLibraryLoanDefaultValueRequest
): any {
  return {
    id: value.id ? value.id : undefined,
    revision: value.revision ? value.revision : undefined
  }
}
